import { client } from "api";

export type UnassignCompanyRequest = { orderId: string; companyId: string };
export type UnassignCompanyResponse = void;

export const unassignCompany = ({ orderId, companyId }: UnassignCompanyRequest) =>
  client
    .delete<UnassignCompanyResponse>(`/order/${orderId}/companies/${companyId}`)
    .then((res) => res.data);
